import HomeIcon from '@mui/icons-material/Home';
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { i18_SIGNUP } from "../../i18nReferences";

/**
 * Success view after a support ticket has been submitted
 * Displays a success message with a home navigation button
 * 
 * @param {Object} props
 * @param {Function} props.onNavigateHome - Callback when home button is clicked
 */
const SignupSupportSuccessView = ({ onNavigateHome }) => {
    const { t } = useTranslation([i18_SIGNUP]);

    return (
        (<Container maxWidth="md">
            <Box sx={{ mt: 4 }}>
                <Alert 
                    severity="success" 
                    sx={{ mb: 2 }}
                    action={
                        <Tooltip title={t('WARNING.GO_HOME_BUTTON')}>
                            <IconButton
                                onClick={onNavigateHome}
                                color="inherit"
                                size="small"
                            >
                                <HomeIcon />
                            </IconButton>
                        </Tooltip>
                    }
                >
                    <Typography variant="subtitle1" gutterBottom sx={{
                        fontWeight: "bold"
                    }}>
                        {t('WARNING.SUCCESS_TITLE')}
                    </Typography>
                    <Typography variant="body2">
                        {t('WARNING.SUCCESS_MESSAGE')}
                    </Typography>
                </Alert>
            </Box>
        </Container>)
    );
};

export default SignupSupportSuccessView;

